const BackGroundImage = require("./background.png");

export { BackGroundImage };
